{
	"title": "Kohlenstoff erfasste Attribute",
	"buttonTitle": "Kohlenstoffabscheidung und -speicherung",
	"table": {
		"materialDescription": "Material",
		"quantity": "Menge",
		"productGwpTotal": "Produkt-GWP-Gesamt",
		"bundledCarbonReductions": "Gebündelte Kohlenstoffreduktionen",
		"remainingGwp": "Verbleibendes GWP",
		"epdForPhysicalMaterial": "EPD für physisches Material",
		"carbonPlantName": "Brevik, Norwegen"
	},
	"declarationDetailsBanner": {
		"rightfulHolderText": "ist der rechtmäßige Inhaber der gemeldeten Kohlenstoffreduktionen."
	},
	"modal": {
		"title": "Kohlenstoffabscheidung und -speicherung",
		"description": "Die Kohlenstoffabscheidung und -speicherung (CCS) ist eine Technologie, die die bei der Kalzinierung und der Nutzung von Brennstoffen im Ofenbetrieb entstehenden Kohlendioxidemissionen (CO2) auffangen kann, um zu verhindern, dass das Kohlendioxid in die Atmosphäre gelangt, und es dauerhaft unterirdisch speichert. Das aufgefangene CO2 aus dem Werk von Heidelberg Materials in Brevik, Norwegen, wird komprimiert und zu einem Speicherort unter der Nordsee transportiert. Die Anlage in unserem Werk in Brevik wird jährlich 400.000 Tonnen CO2 auffangen.",
		"showLink": "Erfahren Sie mehr über den Kohlenstoffabscheidungsprozess",
		"buttonClose": "Schließen"
	},
	"footnote": "1) Kohlenstoffreduktionen kompensieren die Phasen A1-A3 der Lebenszyklusanalyse von Zement."
}
